import { IProduct, Product } from './product';

export interface IExam extends IProduct {
  personId: number;
  applicationId: number;
  specialAccomodations: boolean;
  voucher: string;
  examId: number;
  serviceCodeId: number;
  schedulingLink: string;
  eligibilityBeginDate: string;
  eligibilityEndDate: string;
  collectDemographics: string;
  collectBirthday: string;
  collectDiscipline: boolean;
  reinstatementFee: string;
  examInstructions: string;
  price: number;
  timeLimitEndDate: string;
  expirationDate: string;
  isSubjectToWait: boolean;
  
  
}

export class Exam extends Product implements IExam {
  personId = null;
  applicationId = null;
  specialAccomodations = false;
  voucher = null;
  examId = null;
  serviceCodeId = null;
  schedulingLink = null;
  eligibilityEndDate = null;
  eligibilityBeginDate = null;
  collectDemographics = null;
  collectBirthday = null;
  collectDiscipline=null;
  reinstatementFee = null;
  examInstructions = null;
  price = null;
  timeLimitEndDate = null;
  expirationDate = null;
  isSubjectToWait = false;
}
